export default "__VITE_ASSET__fe013bc3__"